// Please keep in alphabetical order for ease of reading
// Note that although this map is untyped, it must extend FeatureMap, and this is enforced by the call to isFeatureEnabled in ./index.ts
var Features = {
    'grp-discovery-leftnav': {
        description: 'Enables the Groups Discover workflow',
    },
    'grp-screenshotAutomationTest': {},
    'grp-consumerGroupPassSmtpAddressForCreateResponse': {},
    'grp-useGroupsEnabledFromUserConfiguration': {},
    'grp-useInboxGCIForGroups': {},
};
export { Features };
//# sourceMappingURL=Features.js.map